const getDataType = (dataKey) => {
  switch (dataKey) {
    case "energyImported":
      return "energy";
    case "energyExported":
      return "energy";
    case "energyGenerated":
      return "energy";
    case "solarConsumed":
      return "energy";
    case "waterSaved":
      return "water";
    case "gridConsumed":
      return "energy";
    case "netConsumed":
      return "energy";
    case "solarReturned":
      return "energy";
    case "solarFeedIn":
      return "energy";
    case "solarGenerated":
      return "energy";
    case "minNetConsumedAvgPerPerson":
      return "energy per person";
    case "maxNetConsumedAvgPerPerson":
      return "energy per person";
    case "peakSolarCapacity":
      return "energy peak";
    case "peakCapacity":
      return "energy peak";
    case "co2Produced":
      return "mass";
    case "co2Saved":
      return "mass";
    case "selfConsumed":
      return "energy";
    case "selfConsumedPercent":
      return "percentage";
    case "performance":
      return "percentage";
    case "cost":
      return "money";
    case "averageCloudCover":
      return "percentage";
    case "voltage":
      return "voltage";
    case "current":
      return "current";
    case "realEnergyJoules":
      return "energy joules";
    case "realEnergy":
      return "energy";
    case "realPower":
      return "power";
    case "reactiveEnergyJoules":
      return "energy joules";
    case "reactiveEnergy":
      return "energy reactive";
    case "reactivePower":
      return "power reactive";
    case "apparentPower":
      return "power apparent";
    case "powerFactor":
      return "blank";
    case "panelQuantity":
      return "panels";
    case "solarConsumedValue":
      return "money";
    case "gridConsumedValue":
      return "money";
    case "gridFeedInValue":
      return "money";
    case "solarFeedInValue":
      return "money";
    case "netConsumedValue":
      return "money";
    case "solarGeneratedValue":
      return "money";
    default:
      return "blank";
  }
};

export default getDataType;



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/UnitsAndKeys/getDataType.js